import { css } from '@emotion/react';

import { theme } from '../../../theme';

const { colors, spacing, borders, breakpoints, fontWeight, fontSize } = theme;

export const buttonOverride = css`
  text-decoration: underline;
  color: var(--color-link);
  background: none;
  border: none;
  padding: 0;
  font: var(--font-p);
  text-transform: none;
  min-height: 0;
  min-width: 0;
  font-size: 14px;
`;
export const buttonContainer = css`
  display: flex;
  justify-content: flex-end;
  margin-top: ${theme.spacing.lg};
  gap: ${theme.spacing.md};
`;

export const wrapper = css`
  width: 500px;
  padding: 24px;
  background-color: ${colors.white};
  margin: ${spacing.xl} auto;
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
`;

export const passengerFieldsWrapper = css`
  width: 100%;
  display: flex;
  gap: ${spacing.md};

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const inputWrapper = css`
  width: 33%;

  svg {
    margin-top: ${spacing.md};
  }

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
  }
`;

export const section = css`
  background-color: #e8e8e8;
  border-radius: ${borders.radius.sm};
`;
export const sectionContent = css`
  background-color: ${colors.white};
  border-radius: ${borders.radius.sm};
  @media (max-width: ${breakpoints.tablet}) {
    margin-top: ${spacing.sm};
  }
`;
export const content = css`
  flex: 1;
  overflow-y: auto;
  padding-bottom: ${theme.spacing.xl};
`;
export const sectionHeader = css`
  display: flex;
  align-items: center;
  font-size: ${fontSize.md};
  color: ${colors.white};
  background-color: ${colors.blue[1]};
  align-items: center;
  border-top-left-radius: ${borders.radius.md};
  border-top-right-radius: ${borders.radius.md};
  min-height: 56px;
  padding: ${spacing.md};
  @media (max-width: ${breakpoints.tablet}) {
    min-height: 60px;
  }
  @media (max-width: ${breakpoints.mobileM}) {
    flex-direction: column;
  }
`;

export const type = css`
  margin-right: 4px;
`;
export const fontWeightBlack = css`
  font-weight: ${fontWeight.black};
`;
export const inputContainer = css`
  width: 100%;
  @media (max-width: ${breakpoints.mobileM}) {
    display: flex;
    flex-direction: column;
  }
`;
export const innerWrapper = css`
  display: flex;
  gap: ${spacing.sm};
  margin-bottom: ${spacing.sm};
  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;
export const noMargin = css`
  margin: 0;
`;
